import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import dayjs from '../../../../_utils/dayjs.config';

export interface WorkstepContentReadState{
  id: number
  contentId: number
  readDate: Date
  employee: {id: number, firstName?: string, lastName?: string}
}

@Component({
  selector: 'app-workstep-read-state-popover',
  standalone: true,
  imports: [IonicModule, CommonModule],
  templateUrl: './workstep-read-state-popover.component.html',
  styleUrls: ['./workstep-read-state-popover.component.scss'],
})
export class WorkstepReadStatePopoverComponent implements OnInit {

  public dayjs = dayjs

  public contentId: number

  public readStates: WorkstepContentReadState[] = []

  constructor(
    private ticketSrv: TicketEmployee.TicketService
  ) { }

  async ngOnInit() {
    const result: HttpFunctionResult<WorkstepContentReadState[]> = await this.ticketSrv.getWorkstepReadStates(this.contentId);
    if(result.success) this.readStates = result.data
  }

}
